{
  "tabs": {
    "chat": "Vestlus",
    "reminders": "Meeldetuletused",
    "calendar": "Kalender",
    "settings": "Seaded"
  },
  "common": {
    "cancel": "Tühista",
    "save": "Salvesta",
    "confirm": "Kinnita",
    "delete": "Kustuta",
    "back": "Tagasi",
    "close": "Sulge",
    "edit": "Muuda",
    "search": "Otsi",
    "all": "Kõik",
    "loading": "Laadimine...",
    "error": "Midagi läks valesti",
    "notFound": "Ei leitud",
    "tryAgain": "Palun proovi uuesti",
    "retry": "Proovi uuesti",
    "undo": "Võta tagasi",
    "pullToRefresh": "Värskendamiseks tõmba alla",
    "justNow": "just nüüd"
  },
  "auth": {
    "welcome": "Tere tulemast FishMemory-sse",
    "tagline": "Sinu WhatsApp meeldetuletuste assistent, nüüd su taskus.",
    "subtitle": "Sinu WhatsApp meeldetuletuste assistent, nüüd su taskus.",
    "phoneLabel": "Sinu WhatsApp number",
    "phoneHint": "Saadame kinnituskoodi WhatsAppi kaudu",
    "invalidPhone": "Palun sisesta kehtiv telefoninumber",
    "continue": "Jätka",
    "enterPhone": "Sisesta oma WhatsApp number",
    "phonePlaceholder": "Telefoninumber",
    "sendCode": "Saada kood",
    "verifyTitle": "Kinnita oma number",
    "otpSentTo": "6-kohaline kood saadetud numbrile {{phone}} WhatsAppi kaudu",
    "enterFullCode": "Palun sisesta kõik 6 numbrit",
    "invalidOtp": "Vigane kood. Palun proovi uuesti.",
    "otpFailed": "Koodi saatmine ebaõnnestus. Proovi uuesti.",
    "otpResent": "Kood saadetud uuesti",
    "resendIn": "Saada uuesti {{seconds}}s pärast",
    "resendCode": "Saada kood uuesti",
    "enterOtp": "Sisesta WhatsAppi saadetud kood",
    "verify": "Kinnita",
    "resend": "Saada kood uuesti",
    "wrongNumber": "Vale number?",
    "backToPhone": "Tagasi numbrile",
    "editPhone": "Muuda telefoninumbrit",
    "error": "Viga",
    "setupTitle": "Seadistame asjad",
    "setupSubtitle": "Saad neid hiljem seadetes muuta",
    "namePlaceholder": "Sinu nimi",
    "letsGo": "Lõpeta seadistus",
    "skipForNow": "Jäta vahele"
  },
  "chat": {
    "title": "FishMemory",
    "placeholder": "Kirjuta sõnum...",
    "inputPlaceholder": "Kirjuta sõnum...",
    "typing": "FishMemory kirjutab...",
    "online": "Võrgus",
    "connecting": "Ühendamine...",
    "reconnecting": "Ühenduse taastamine...",
    "offline": "Võrgust väljas",
    "empty": "Alusta vestlust",
    "emptyHint": "Loo meeldetuletusi, vaata oma ajakava või küsi abi.",
    "emptyAction": "Saada näidismeeldetuletus",
    "actions": "Vestluse toimingud",
    "keep": "Hoia sõnumeid",
    "clearTitle": "Tühjenda vestlus",
    "clearConfirm": "Kustutada kõik sõnumid sellest seadmest? Seda ei saa tagasi võtta.",
    "clear": "Tühjenda vestlus",
    "optionSelected": "Valitud: {{label}}",
    "sendingSelection": "Saadetakse...",
    "connectionLost": "Ühenduse taastamine..."
  },
  "reminders": {
    "title": "Minu meeldetuletused",
    "active": "Aktiivne",
    "today": "Täna",
    "thisWeek": "Selle nädala",
    "history": "Ajalugu",
    "items": "üksused",
    "emptyTitle": "Meeldetuletusi pole veel",
    "emptySubtitle": "Loo vestluses ja need kuvatakse siin.",
    "emptyAction": "Ava vestlus",
    "filterActive": "Aktiivne",
    "filterToday": "Täna",
    "filterWeek": "Selle nädala",
    "filterHistory": "Ajalugu",
    "emptyState": "Meeldetuletusi pole veel. Alusta vestlust!",
    "swipeDone": "Valmis",
    "swipeSnooze": "Lükka edasi",
    "swipeDelete": "Kustuta",
    "search": "Otsi meeldetuletusi...",
    "upcoming": "Peatselt",
    "completed": "Valmis",
    "overdue": "Möödas",
    "tomorrow": "Homme",
    "synced": "Sünkroonitud {{value}}",
    "swipeHint": "Pühkige meeldetuletusel lisatoimingute jaoks",
    "noResults": "Otsingule ei vastanud ühtegi meeldetuletust",
    "noResultsHint": "Proovi teist märksõna või tühjenda otsing",
    "deleteAllFailed": "Kõigi meeldetuletuste kustutamine ebaõnnestus"
  },
  "calendar": {
    "title": "Kalender",
    "today": "Täna",
    "tomorrow": "Homme",
    "completed": "valmis",
    "noEvents": "Pole ühtegi sündmust",
    "noEventsSubtitle": "Vali kuupäev, et näha meeldetuletusi ja kalendrisündmusi.",
    "googleEvent": "Google Kalender",
    "legendActive": "Aktiivne",
    "legendRecurring": "Korduv",
    "legendDone": "Valmis",
    "legendGoogle": "Google",
    "previousMonth": "Eelmine kuu",
    "nextMonth": "Järgmine kuu",
    "previousYear": "Eelmine aasta",
    "nextYear": "Järgmine aasta",
    "goToToday": "Mine tänasele",
    "all": "Kõik",
    "active": "Aktiivne",
    "done": "Valmis",
    "paused": "Peatatud"
  },
  "settings": {
    "title": "Seaded",
    "profile": "Profiil",
    "name": "Kuvamise nimi",
    "enterName": "Sisesta oma nimi",
    "language": "Keel",
    "uiLanguage": "Rakenduse keel",
    "uiLanguageHelp": "Muudab rakenduse kasutajaliidest, kalendri silte ja paigutust ainult selles seadmes.",
    "serverLanguage": "Vestluse keel",
    "serverLanguageHelp": "Muudab serveri vastuste ja meeldetuletuste keelt sinu kontol.",
    "timezone": "Ajavöönd",
    "currentTimezone": "Praegune ajavöönd",
    "timezoneHelp": "Kõik meeldetuletuste ajad kuvatakse selle ajavööndi järgi.",
    "timezonePlaceholder": "America/New_York",
    "timezoneSave": "Salvesta ajavöönd",
    "timezoneSaved": "Ajavöönd uuendatud",
    "detect": "Tuvasta",
    "detectFailed": "Ajavööndi tuvastamine ebaõnnestus",
    "autoDetect": "Automaatne GPS-ist",
    "notifications": "Teavitused",
    "notificationsHelp": "Järelmeeldetuletused kontrollivad korduvaid teavitusi pärast meeldetuletuse saatmist. Seadme tasandi teavituste load haldad endiselt telefoni seadetes.",
    "pushEnabled": "Push-teavitused",
    "autoDoneOnFire": "Märgi automaatselt tehtuks",
    "autoDoneOnFireDesc": "Kui välja lülitatud, jäävad meeldetuletused aktiivseks kuni nende märkimiseni tehtuks.",
    "googleCalendar": "Google Kalender",
    "google": "Google Kalender",
    "googleConnected": "Ühendatud",
    "googleDisconnected": "Pole ühendatud",
    "googleConnectedHelp": "Uued meeldetuletused saab automaatselt kalendrisse sünkroonida.",
    "googleDisconnectedHelp": "Ühenda Google Kalender, et hoida meeldetuletused ja sündmused kooskõlas.",
    "googleConnectFailed": "Google Kalendriga ühendamine ebaõnnestus",
    "connected": "Ühendatud",
    "disconnected": "Pole ühendatud",
    "connect": "Ühenda",
    "disconnect": "Ühenda lahti",
    "autoSync": "Automaatne uute meeldetuletuste sünkroonimine",
    "autosync": "Automaatne uute meeldetuletuste sünkroonimine",
    "subscription": "Tellimus",
    "trialUsed": "Prooviversioon: kasutatud {{used}}/{{total}}",
    "trialStatus": "Prooviversioon saadaval",
    "activeStatus": "Aktiivne tellimus",
    "expiredStatus": "Tellimus aegunud",
    "unsubscribedStatus": "Pole tellitud",
    "about": "Teave",
    "version": "Versioon",
    "logout": "Logi välja",
    "logoutTitle": "Logi välja",
    "logoutConfirm": "Oled kindel, et soovid välja logida?",
    "noName": "Nime pole määratud",
    "serverConnection": "Serveri ühendus",
    "serverUrl": "Serveri URL",
    "serverEdit": "Muuda",
    "saveReconnect": "Salvesta ja ühenda uuesti",
    "resetDefault": "Lähtesta vaikeseadetele",
    "invalidServerUrlTitle": "Kehtetu serveri URL",
    "invalidServerUrlMessage": "Sisesta kehtiv http või https serveri URL, näiteks https://example.com",
    "uiLanguageChangeFailed": "Rakenduse keele muutmine ebaõnnestus. Palun proovi uuesti.",
    "serverLanguageChangeFailed": "Vestluse keele muutmine ebaõnnestus. Palun proovi uuesti.",
    "timezoneChangeFailed": "Ajavööndi muutmine ebaõnnestus. Palun proovi uuesti.",
    "autoSyncChangeFailed": "Automaatse sünkroonimise uuendamine ebaõnnestus. Palun proovi uuesti.",
    "nameChangeFailed": "Kuvamise nime uuendamine ebaõnnestus. Palun proovi uuesti.",
    "trialDays": "Free trial: {{daysLeft}} day(s) left",
    "trialEnds": "Trial ends {{date}}"
  },
  "reminder": {
    "body": "Meeldetuletuse üksikasjad",
    "editTime": "Muuda aega",
    "rename": "Nimeta ümber",
    "snooze": "Lükka edasi",
    "snooze15": "Lükka edasi 15 minutit",
    "pause": "Peata",
    "pauseReminder": "Peata meeldetuletus",
    "resume": "Jätka",
    "resumeReminder": "Jätka meeldetuletust",
    "skip": "Jäta järgmine vahele",
    "skipOccurrence": "Jäta see kord vahele",
    "syncGoogle": "Sünkrooni Google'iga",
    "delete": "Kustuta",
    "deleteTitle": "Kustuta meeldetuletus",
    "deleteConfirm": "See meeldetuletus kustutatakse jäädavalt.",
    "deleteRecurringTitle": "Kustuta korduv meeldetuletus",
    "deleteRecurringMessage": "Kas soovid selle korra vahele jätta või kogu sarja kustutada?",
    "deleteThisOccurrence": "Jäta see kord vahele",
    "deleteEntireSeries": "Kustuta kogu sari",
    "done": "Valmis",
    "markDone": "Märgi tehtuks",
    "undo": "Taasta",
    "undoPrompt": "Kas vajad seda uuesti aktiivseks? Taasta nüüd.",
    "recurring": "Korduv",
    "nextRun": "Järgmine kord",
    "oneTime": "Ühekordne",
    "pending": "Ootel",
    "sent": "Saadetud",
    "paused": "Peatatud",
    "active": "Aktiivne",
    "snoozed": "Edasi lükatud",
    "localTime": "Kuvatud sinu kohalikus ajavööndis",
    "recurrence": "Kordumine",
    "created": "Loodud",
    "tags": "Sildid",
    "fireCount": "Kordade arv",
    "actions": "Toimingud",
    "none": "Puudub",
    "snoozeFailed": "Meeldetuletuse edasi lükkamine ebaõnnestus",
    "pauseFailed": "Meeldetuletuse peatamine ebaõnnestus",
    "resumeFailed": "Meeldetuletuse jätkamine ebaõnnestus",
    "skipFailed": "Meeldetuletuse vahele jätmine ebaõnnestus",
    "doneFailed": "Meeldetuletuse märkimine tehtuks ebaõnnestus",
    "undoFailed": "Meeldetuletuse oleku taastamine ebaõnnestus",
    "deleteFailed": "Meeldetuletuse kustutamine ebaõnnestus",
    "rescheduleTitle": "Kas soovid ajastust muuta?",
    "rescheduleMsg": "See meeldetuletus on möödas. Kas soovid selle uuesti ajastada?",
    "reschedule15": "15 minuti pärast",
    "reschedule60": "1 tunni pärast",
    "keepOverdue": "Jäta nii nagu on"
  },
  "onboarding": {
    "slide1Title": "Tere tulemast FishMemory-sse",
    "slide1Sub": "Sinu isiklik meeldetuletuste assistent — töötab WhatsAppiga ja mahub taskusse.",
    "slide2Title": "Lihtsalt vestle loomulikult",
    "slide2Sub": "Kirjuta meeldetuletused nii nagu mõtled: „Tuleta homme kell 15 emale helistamist meelde“ — meie hoolitseme ülejäänu eest.",
    "slide3Title": "Ära kunagi midagi maha maga",
    "slide3Sub": "Saavuta õigeaegsed teavitused, korralda siltidega ja hoia kõike olulist kontrolli all.",
    "getStarted": "Alusta",
    "next": "Järgmine",
    "firstReminderTitle": "Loo oma esimene meeldetuletus!",
    "firstReminderHint": "Proovi kirjutada midagi sellist:",
    "firstReminderExample": "Tuleta homme kell 9 hommikul vee joomist meelde",
    "gotIt": "Sain aru!",
    "notifRationaleTitle": "Ole õigel ajal",
    "notifRationaleBody": "FishMemory vajab teavitusi, et sind õigel ajal meelde tuletada. Saad teavitusi ainult loodud meeldetuletuste kohta.",
    "notifRationaleAllow": "Luba teavitused",
    "notifRationaleLater": "Võib-olla hiljem",
    "swipeHint": "Pühkige paremale kiirete toimingute jaoks →",
    "calendarDragHint": "Lohista laiendamiseks ↕"
  }
}
